import { CodeListItemWire } from 'app/components/options-handler/types';
import { objectOfType } from 'app/infrastructure/data/object';
import { ComplexValue } from 'app/types-shared';

export const mapCategories = (codes: ComplexValue<number | string>[], wireCodes: CodeListItemWire[] = []) =>
  codes.map(
    (code, index) => ({ ...code, category: wireCodes[index]?.category })
  );

export const mapDescendantCount = (codes: ComplexValue<number | string>[], wireCodes: CodeListItemWire[] = []) =>
  codes.map(
    (code, index) => ({
      ...code, ...(wireCodes[index]?.descendantCount > 0 && {
        descendants: [objectOfType<ComplexValue<number | string>>()]
      })
    })
  );

export const mergePathWithList = (codes: ComplexValue<number>[], path: ComplexValue<number>): ComplexValue<number>[] => {

  if (!path || codes.some(code => code.value === path.value)) {
    return codes;
  }

  return [{
    ...path,
    descendants: mergePathWithList(codes, path.descendants && path.descendants[0])
  }];
};

export const mapListToStore = (codeItems: CodeListItemWire[], path: ComplexValue<number>): ComplexValue<number>[] => {

  const codeList = codeItems && codeItems
    .map(item => ({
      value: item?.v,
      description: item?.d,
      ...(item?.ld && { longDescription: item.ld }),
      descendants: item.descendantCount ? [{ value: -1 }] : undefined,
      backgroundColor: item?.b
    })) || [] as any[];

  return mergePathWithList(codeList, path);
};
